import UsersApi, { UsersKey } from '@/services/users.api'
import { useMutation } from '@api/hooks'
import { User } from '@domain'
import { UpdatePrefsReq } from '@services/users.types'
import { useQueryClient } from '@tanstack/react-query'

type Params = {
	onSuccess?: () => void
}

/**
 * Hook to update a user's preferences
 */
export default function useUpdatePreferences({ onSuccess }: Params = {}) {
	const queryClient = useQueryClient()
	return useMutation({
		mutationFn: (request: UpdatePrefsReq) => UsersApi.updatePreferences(request),
		onSuccess: (data) => {
			const me: User = queryClient.getQueryData(UsersKey.me)
			const cleanedPreferences = me.userPreferences.filter(
				(d) => d.key !== data.data.data.userPreferences[0].key
			)
			const updated = {
				...me,
				userPreferences: [...cleanedPreferences, ...data.data.data.userPreferences],
			}
			queryClient.setQueryData(UsersKey.me, updated)

			if (onSuccess) {
				onSuccess()
			}
		},
	})
}
